// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceDropletAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.785 9.17a55.914 55.914 0 0 0-2.026-3.728.14.14 0 0 0-.244 0A55.94 55.94 0 0 0 9.49 9.17c-1.28 2.605-2.173 5.09-2.173 6.707 0 2.166 1.825 4.123 4.32 4.123 2.496 0 4.32-1.957 4.32-4.123 0-1.618-.892-4.102-2.172-6.707zm-8.388 6.707c0-3.706 3.29-9.563 5.093-12.494l.057-.093c.262-.424.49-.782.668-1.06a.501.501 0 0 1 .844 0c.18.278.407.636.669 1.06l.057.093c1.802 2.93 5.092 8.788 5.092 12.494 0 3.381-2.793 6.123-6.24 6.123-3.446 0-6.24-2.741-6.24-6.123zm8.88-.423h.48c.266 0 .484.226.442.498-.125.804-.54 1.54-1.072 2.095-.533.555-1.24.987-2.012 1.117-.261.044-.477-.183-.477-.46v-.5c0-.276.218-.496.472-.575a2.41 2.41 0 0 0 .998-.642c.3-.313.513-.679.617-1.04.076-.265.287-.493.553-.493z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceDropletAlt;
